import cn from 'classnames';
import { useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import default_image from '../../../../../assets/media/icons/products.png';
import { Column, Row, WhiteBlock } from '../../../../../components/Basic/Blocks/index.js';
import { Button, CheckButton } from '../../../../../components/Basic/Buttons/index.js';
import { DropDown, NavLink } from '../../../../../components/Basic/Elements/index.js';
import { TableCell, TableLine } from '../../../../../components/Basic/Table/index.js';
import { Text, TextGrey } from '../../../../../components/Basic/WrapsStyle/index.js';
import { TO_POSING, TO_SHIPMENT, TYPE_BUTTONS } from '../../../../../constans/index.js';
import { formFullDate, formFullDateWithSeconds } from '../../../../../utils/index.js';
import { WIDTH_POSTING } from '../index.js';
import styles from './styles.module.scss';

const STATE = {
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Собран', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
};

const COLOR_MARKET = {
  wb: '#6c11c9',
  yandex: 'rgb(193 61 0)',
  ozon: 'rgb(19,79,231)',
  megamarket: 'rgb(13,131,25)',
  kuper: 'rgb(13,131,25)',
};

const ReviewsLine = ({
  MODES,
  FILTER,
  tab,
  isAdmin = false,
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsSelect = {},
  selectPosting = () => { },
  isMany = false,
  changePostings = () => { },
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const [info, setInfo] = useState(false);

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const scan_time_order = order.scan_time?.pick ? formFullDateWithSeconds(order.scan_time.pick) : null;
  const second_scan_time_order = order.scan_time?.packager ? formFullDateWithSeconds(order.scan_time.packager) : null;
  const sort_scan_time_order = order.scan_time?.sort ? formFullDateWithSeconds(order.scan_time.sort) : null;

  return (
    <>
      <TableLine key={order.market_order_number}>
        <TableCell width={WIDTH_POSTING[9]}>
          <CheckButton
            checked={postingsSelect[order.posting_number]}
            onSelect={() => selectPosting(order.posting_number)}
          />
        </TableCell>

        <TableCell width={WIDTH_POSTING[0]}>
          {isAdmin ? (
            <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
              {order.posting_number}
            </Link>
          ) : (
            <>{order.posting_number} </>
          )}{' '}
          {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
          <Row style={{ width: '100%' }}>
            {isMany && (
              <NavLink
                to={TO_SHIPMENT(order.shipmentId)}
                target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '16px', width: 'auto', marginRight: '5px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            )}
            {order.market === 'wb' && (
              <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
          </Row>
          <div className={styles.scan_time} onMouseOver={() => setInfo(true)} onMouseLeave={() => setInfo(false)}>
            {scan_time_order} <br />
            {info && (
              <DropDown styles={styles.all_info} close={() => setInfo(false)}>
                <WhiteBlock styles={styles.init}>
                  <TextGrey style={{ marginBottom: '4px' }}>Пропик:</TextGrey>
                  <Text fontSize={18} fontWeight={600}>{`${order.scan_user.pick}`}</Text>
                  <div className={styles.scan_time}>({scan_time_order})</div>

                  {second_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Упаковка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.packager}`}</Text>
                      <div className={styles.scan_time}>
                        ({second_scan_time_order}){' '}
                        {order.scan_id.packager && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.packager}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  {sort_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Сортировка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.sort}`}</Text>
                      <div className={styles.scan_time}>
                        ({sort_scan_time_order}){' '}
                        {order.scan_id.sort && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.sort}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </WhiteBlock>
              </DropDown>
            )}
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            {order.products.map((p, k) => {
              const data = map[p.offer_id] || {};
              const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
              const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`}>
                  <div key={k} className={styles.div_line_images}>
                    <div className={styles.wrapper}>
                      <img
                        onClick={() => openImageViewer(img)}
                        className={styles.preview}
                        src={img.length > 0 ? img[0] : undefined}
                      />
                    </div>
                    <Column>
                      <div className={styles.name}>
                        {`${p.ordered_quantity} x ${p.name}  `}
                        <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                          {p.offer_id}
                        </div>
                      </div>
                      {scan_time && (
                        <div className={styles.scan_time}>
                          {scan_time} {p.scan_user && `(${p.scan_user})`}
                        </div>
                      )}
                    </Column>
                  </div>
                </Column>
              );
            })}
          </Column>
        </TableCell>

        <TableCell width={WIDTH_POSTING[0]} center={true}>
          <Column>
            <ReactStars size={16} value={order.review.rating} activeColor={'rgb(255 56 5'} edit={false} />
            {formFullDate(order.review.createdDate)}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[14]}>
          <Column>
            {order.review?.comment?.length > 0 && (
              <Row>
                <Text>
                  <span style={{ fontSize: '14px', fontWeight: '600' }}>Комментарий: </span>
                  {order.review.comment}
                </Text>
              </Row>
            )}

            {order.review?.pros?.length > 0 && (
              <Row>
                <Text>
                  <span style={{ fontSize: '14px', fontWeight: '600' }}>Достоинства: </span>
                  {order.review.pros}
                </Text>
              </Row>
            )}

            {order.review?.cons?.length > 0 && (
              <Row>
                <Text>
                  <span style={{ fontSize: '14px', fontWeight: '600' }}>Недостатки: </span>
                  {order.review.cons}
                </Text>
              </Row>
            )}

            {order.review?.images && (
              <Row style={{ marginTop: '10px' }}>
                {order.review?.images?.map((img) => (
                  <div className={styles.wrapper_comment_image}>
                    <img
                      onClick={() => openImageViewer(order.review?.images)}
                      className={styles.preview_comment_image}
                      src={img.length > 0 ? img : undefined}
                    />
                  </div>
                ))}
              </Row>
            )}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[14]}>
          <Row>
            <Button
              type={TYPE_BUTTONS.WHITE}
              style={{ marginRight: '15px' }}
              disabled={order.review.is_checked}
              onClick={() =>
                changePostings([order.posting_number], 'checkups', {
                  checkup_category: 'Камера',
                  reason_type: 'Отзыв',
                })
              }
            >
              Перенести в проверку ЗНК
            </Button>
            <Button
              type={TYPE_BUTTONS.GREEN}
              disabled={order.review.is_checked}
              onClick={() => changePostings([order.posting_number], 'is_review_checked', true)}
            >
              Перенести в архив
            </Button>
          </Row>
        </TableCell>
        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
    </>
  );
};

export default ReviewsLine;
